import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcDoughnutChartHole]'
})
export class DoughnutChartHoleDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
